import {
  HStack,
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
} from "@chakra-ui/react";
import { FaComment, FaGear, FaChevronDown } from "react-icons/fa6";
import { SearchBar } from "components/Navbars/SearchBar/SearchBar";
import React from "react";

export default function ProjectLinks({
  onChatOpen,
  onOpen,
  onPathSelect,
  paths,
  shouldShowSearch,
  selectedPath,
}) {
  return (
    <HStack pe={{ sm: "0px", md: "16px" }} w={{ sm: "100%", md: "auto" }}>
      {!!paths && paths.length > 0 && (
        <Menu>
          <MenuButton
            as={Button}
            rightIcon={<FaChevronDown />}
            size="sm"
            variant={selectedPath ? "solid" : "ghost"}
          >
            {selectedPath || "All cameras"}
          </MenuButton>
          <MenuList>
            <MenuItem onClick={() => onPathSelect(null)}>All Cameras</MenuItem>
            {paths.map((path, index) => (
              <MenuItem
                fontWeight={selectedPath === path ? "bold" : "normal"}
                key={index}
                onClick={() => onPathSelect(path)}
              >
                {path}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      )}
      {!!shouldShowSearch && <SearchBar me="18px" />}
      <IconButton
        aria-label="Open chat"
        icon={<Icon as={FaComment} />}
        onClick={onChatOpen}
        size="sm"
        variant="ghost"
      />
      <IconButton
        aria-label="Open settings"
        icon={<Icon as={FaGear} />}
        onClick={onOpen}
        size="sm"
        variant="ghost"
      />
    </HStack>
  );
}
